<template>
  <a
    v-tooltip="{
      content: tooltip,
      classes: 'badge-theme',
    }"
    :class="badgeClass"
    :href="href"
    :target="target"
    @click.prevent="goto"
  >
    <i :class="icon"></i>
    {{ name }}

    <template v-if="openNew && href">
      <font-awesome-icon :icon="['fal', 'share-square']" />
    </template>
    <template v-else-if="entityId && href">
      <font-awesome-icon :icon="['fal', 'play']" />
    </template>
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    tooltip: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },

    entityId: {
      type: [Number, String],
    },
    openNew: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-info",
      icon: ["fal", "head-side"],
    };
  },

  computed: {
    href() {
      if (this.entityId) {
        if (this.$can("read", "customers")) {
          return `/customers/${this.entityId}/edit`;
        }
      }

      return null;
    },
    target() {
      return this.entityId && this.openNew && this.href ? "_blank" : null;
    },
    badgeClass() {
      return `badge ${this.color} ${this.size}`;
    },
  },

  methods: {
    goto() {
      if (!this.entityId || !this.href) {
        return;
      }

      if (this.openNew) {
        window.open(this.href);
      } else {
        this.$router.push({
          name: "customers.edit",
          params: { id: this.entityId },
        });
      }
    },
  },
};
</script>
